import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import {
  StudyEditForm,
  useStudyEditForm,
  PublishConfirmationModal,
  StudyFormProvider,
  DuplicateStudyButton,
} from '@/features/studies';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Publish } from '@mui/icons-material';
import { Edit } from '@refinedev/mui';

export const StudyEdit = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>Study not found</div>;
  }

  return <StudyEditContent id={id} />;
};

const StudyEditContent = ({ id }: { id: string }) => {
  const { t } = useTranslation();
  const form = useStudyEditForm({ id });
  const {
    publishButtonProps,
    isFirstLoading,
    publishModalProps,
    saveButtonProps,
    refineCore: { formLoading },
  } = form;

  const disabledSaveButtonProps = {
    ...saveButtonProps,
  };

  if (isFirstLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <Edit
      isLoading={formLoading}
      saveButtonProps={disabledSaveButtonProps}
      title={t('pages.studies.create.title')}
      footerButtons={({ defaultButtons }) => (
        <>
          <DuplicateStudyButton studyId={id} variant="text" />
          {defaultButtons}
          <Button
            variant="contained"
            color="primary"
            onClick={publishButtonProps.onClick}
            disabled={publishButtonProps.loading || formLoading}
            sx={{ ml: 1 }}
            startIcon={<Publish />}
          >
            {t('buttons.publish')}
          </Button>
        </>
      )}
    >
      <StudyFormProvider {...form}>
        <StudyEditForm />
      </StudyFormProvider>
      <PublishConfirmationModal {...publishModalProps} />
    </Edit>
  );
};
